
(
    function (skyward, $, undefined)
    {
        skyward.gradebookquestion = skyward.gradebookquestion || {};

        var init = function (selector)
        {
            var templateFilterDMSE = $(selector + " .AssignmentTemplateFilter");
            if (templateFilterDMSE.length > 0)
            {
                templateFilterDMSE.on("modalClosed", function ()
                {
                    var browse = $(selector + " .FilterableTeacherTemplateBrowse");
                    skyward.browse.tryRefreshDetailsPanel(browse.attr("id"));
                });
            }

            var matchingAnswersContainer = $(selector + " .matchingAnswersContainer");

            if (matchingAnswersContainer.length > 0)
            {
                matchingAnswersContainer.on("change", ".matchingAnswerChoiceAnswers", onChoiceAnswerChange);

                $(selector + " .matchingAnswerChoicesContainer").on("change", ".matchingAnswerChoice", onChoiceTextChange);

                matchingAnswersContainer.on("change", ".matchingAnswerMatch ", onMatchTextChange);

                matchingAnswersContainer.on("embeddedImagedLoaded", ".fileUploadElement", embeddedImageChange);

                matchingAnswersContainer.on("change", ".matchingAnswerHiddenImage", embeddedImageChange);

                matchingAnswersContainer.on("openedAdvancedEditor", ".advancedTextArea", function ()
                {
                    var parentContainer = $(this);
                    parentContainer.siblings(".editorSpacer").first().removeClass("displayInlineBlock");

                });

                matchingAnswersContainer.on("closedAdvancedEditor", ".advancedTextArea", function ()
                {
                    var parentContainer = $(this);
                    parentContainer.siblings(".editorSpacer").first().addClass("displayInlineBlock");
                });

                matchingAnswersContainer.find("img.questionAnswerMedia").each(function ()
                {
                    var img = $(this);
                    img.on("load", function () { repositionLines(matchingAnswersContainer); });

                });

                var ro = new ResizeObserver(function()
                {
                    matchingAnswersContainer.each(function ()
                    {
                        repositionLines($(this));
                    });
                });
                matchingAnswersContainer.find(".matchingAnswerMatchesContainer").each(function ()
                {
                    ro.observe($(this)[0]);
                })
                matchingAnswersContainer.find(".matchingAnswerChoicesContainer").each(function ()
                {
                    ro.observe($(this)[0]);
                })

                matchingAnswersContainer.each(function ()
                {
                    repositionLines($(this));
                });
            }

            var imageClick = function ()
            {
                var image = $(this);
                var src = image.prop("src");
                var fullsizeImage = "<img src='" + src + "'/>";

                var img = new Image();
                img.onload = function ()
                {
                    var popupWidthPercent = .9;
                    var popupPadding = 35;
                    var maxWidth = ($(document).width() * popupWidthPercent) - popupPadding;

                    if (this.width > maxWidth)
                    {
                        this.width = maxWidth
                    };

                    var options =
                    {
                        draggable: true,
                    };
                    var layer = skyward.modalLayer.showDialog("Image", img, [{ text: "Close", "icon": "Close" }], options);
                }
                img.src = src;
            }
            matchingAnswersContainer.on('click', 'img', imageClick);
            $(selector + " .onlineAssignmentImageContainer, " + selector + " .studentAssignmentDetailsStudentAnswerSpan").on("click", "img", imageClick);
        };

        var getBackingData = function (backingDataElement)
        {
            var dataString = skyward.controls.getValue(backingDataElement);
            var data;

            if (dataString == "")
            {
                //Initialize for child record gen
                data = JSON.parse(skyward.controls.getOriginalValue(backingDataElement));
            }
            else
            {
                var elem = document.createElement('textarea');
                elem.innerHTML = dataString;
                var decoded = elem.value;
                data = JSON.parse(decoded);
            }

            return data;
        };

        var onChoiceAnswerChange = function ()
        {
            var selectInput = $(this);

            if (!selectInput.hasClass("matchingAnswerChoiceAnswersStudentSide"))
            {
                var identifier = getIdentifier(selectInput.parent(), false);
                var answerIdentifier = getAnswerIdentifierFromChoiceSelection(selectInput);
                var backingDataElement = selectInput.parents(".matchingAnswersContainer").find(".matchingBackingData");
                var backingData = getBackingData(backingDataElement);

                var selectedMatch = getMatch(backingData, answerIdentifier);
                var choice = getChoice(backingData, identifier);

                //choice can be null if this is triggered by the clear button (on the first question within the add question workflow)
                if (choice === null)
                {
                    return;
                }

                choice.AnswerText = selectedMatch == null ? null : selectedMatch.Text;
                choice.AnswerIdentifier = selectedMatch == null ? null : selectedMatch.Identifier;

                skyward.controls.setValue(backingDataElement, JSON.stringify(backingData));
            }

            repositionLine(selectInput.parents(".matchingAnswerChoiceContainer").first());
            var matchingAnswersContainer = selectInput.parents(".matchingAnswersContainer").first();
            repositionLines(matchingAnswersContainer);
            removeBordersForUnusedMatches(selectInput.parents(".matchingAnswersContainer"));
        };

        var onChoiceTextChange = function () {
            var textbox = $(this);
            var backingData = getBackingData(textbox.parents(".matchingAnswersContainer").find(".matchingBackingData"));
            var identifier = getIdentifier(textbox.parents(".matchingAnswerChoiceContainer").first(), false);
            var choice = getChoice(backingData, identifier);
            choice.Choice = textbox.val();
            choice.DisplayMode = skyward.controls.getValue(textbox.parents(".matchingAdvancedTextArea").find(".advancedTextAreaDisplayMode"));
            skyward.controls.setValue(textbox.parents(".matchingAnswersContainer").find(".matchingBackingData"), JSON.stringify(backingData));
        };

        var onMatchTextChange = function () {
            var textbox = $(this);
            var backingData = getBackingData(textbox.parents(".matchingAnswersContainer").find(".matchingBackingData"));
            var identifier = getIdentifier(textbox.parents(".matchingAnswerMatchContainer").first(), true);
            var match = getMatch(backingData, identifier);

            //match can be null if this is triggered by the clear button (on the first question within the add question workflow)
            if (match === null)
            {
                return;
            }

            match.Text = textbox.val();
            match.DisplayMode = skyward.controls.getValue(textbox.parents(".matchingAdvancedTextArea").find(".advancedTextAreaDisplayMode"));

            var choices = getChoicesForMatch(backingData, match)
            for (var i = 0; i < choices.length; i++)
            {
                var choice = choices[i];
                choice.AnswerText = match.Text;
            }
            skyward.controls.setValue(textbox.parents(".matchingAnswersContainer").find(".matchingBackingData"), JSON.stringify(backingData));
        };

        var embeddedImageChange = function ()
        {
            var element = $(this);
            var matchingAnswersContainer = element.parents(".matchingAnswersContainer").first();
            repositionLines(matchingAnswersContainer);
        };

        var repositionLines = function (matchingAnswersContainer)
        {
            var middleDiv = matchingAnswersContainer.find(".middleDiv");
            var middleDivWidth = middleDiv.width();
            middleDiv.empty();
            matchingAnswersContainer.find(".matchingAnswerChoiceContainer:not(.template)").each(function ()
            {
                var matchingAnswerChoiceContainer = $(this);
                middleDiv.append(addLine(matchingAnswerChoiceContainer, middleDivWidth, matchingAnswersContainer.height()));

                repositionLine(matchingAnswerChoiceContainer);
            });
        };

        var addLine = function (choiceDiv, width, height)
        {
            var number = choiceDiv.prevAll(".matchingAnswerChoiceContainer").length + 1;
            var lineSvg = '<svg class="matchingChoiceSvg" style="width: ' + width + 'px; height: ' + height + 'px">';
            lineSvg += '<line class="hidden matchingChoiceLine' + number + '"></line></svg>';

            return $(lineSvg);
        };

        var getMatchingLineAdjustments = function (choiceDiv)
        {
            var choiceInput = choiceDiv.find(".matchingAnswerChoice").first();

            if (choiceInput.length < 1)
            {
                choiceInput = choiceDiv.find(".matchingAnswerChoiceAnswers").first()
            }

            if (choiceInput.length < 1)
            {
                return 0;
            }

            var choiceInputMiddleHeight = choiceInput.outerHeight(true) / 2;
            var adjustedHeightPosition = choiceInputMiddleHeight;

            return adjustedHeightPosition;
        };

        var setLineCoordinates = function (choiceDiv, line, middleDiv, choicePosition, matchPosition)
        {
            var adjustedHeightPosition = getMatchingLineAdjustments(choiceDiv);
            var divMarginTop = 0;
            var leftMargin = 0;
            if (choiceDiv.parents(".dataObjectViewer").length > 0)
            {
                divMarginTop = 25;
            }

            var fieldsetPadding = 20;

            if (choiceDiv.parents("fieldset").length > 0)
            {
                divMarginTop += fieldsetPadding;
            }

            if (choiceDiv.children("img.questionAnswerMedia").length)
            {
                leftMargin += choiceDiv.children("img.questionAnswerMedia")[0].height / 2
            }
            else if (choiceDiv.find("img.embeddedImageDisplay").length)
            {
                leftMargin += choiceDiv.find("img.embeddedImageDisplay").parent().height() / 2
            }

            var x1 = 0;
            var y1 = choicePosition == null ? 0 : (choicePosition.top + adjustedHeightPosition + divMarginTop + leftMargin);
            var x2 = middleDiv.width();
            var y2 = matchPosition == null ? 0 : (matchPosition.top + divMarginTop);

            line.attr('x1', x1).attr('y1', y1).attr('x2', x2).attr('y2', y2);
        }

        var getColor = function (matchNumber, choiceDiv)
        {
            var answerSVG = choiceDiv.children('svg');
            if (answerSVG.length > 0)
            {
                if (answerSVG.hasClass('onlineAssignmentCorrectAnswerCheckmark'))
                {
                    return '#CAF0CA';
                }
                else if (answerSVG.hasClass('onlineAssignmentWrongAnswerCheckmark'))
                {
                    return '#FDABAD';
                }
            }
            else
            {
                switch (matchNumber)
                {
                    case 1:
                        return '#AEC6CF';
                    case 2:
                        return '#04b5f7';
                    case 3:
                        return '#8902f7';
                    case 4:
                        return '#FFB347';
                    case 5:
                        return '#B19CD9';
                    case 6:
                        return '#836953';
                    case 7:
                        return '#CFCFC4';
                    case 8:
                        return '#CB99C9';
                    case 9:
                        return '#966FD6';
                    case 10:
                        return '#375bdd';
                    case 11:
                        return '#d35400';
                    case 12:
                        return '#1abc9c';
                    case 12:
                        return '#3498db';
                    case 13:
                        return '#8e44ad';
                    case 14:
                        return '#e67e22';
                    case 15:
                        return '#16a085';
                    case 16:
                        return '#95a5a6';
                    case 17:
                        return '#f1c40f';
                    case 18:
                        return '#2980b9';
                    case 19:
                        return '#2c3e50';
                    case 20:
                        return '#004225';
                    case 21:
                        return '#FFC1CC';
                    case 22:
                        return '#F7E7CE';
                    case 23:
                        return '#B2EC5D';
                    case 24:
                        return '#FF7F50';
                    case 25:
                        return '#8B008B';
                    case 26:
                        return '#FCF75E';
                    default:
                        return 'black';
                }
            }
        };

        var setMatchingBorder = function (div, color) {
            div.css({
                "border-color": color,
                "border-width": "2px",
                "border-style": "solid"
            });
        };

        var repositionLine = function (choiceDiv)
        {
            var matchingAnswersContainer = choiceDiv.parents(".matchingAnswersContainer").first();
            var middleDiv = matchingAnswersContainer.find(".middleDiv");
            var choiceNumber = choiceDiv.prevAll(".matchingAnswerChoiceContainer").length + 1;

            var choicePosition = choiceDiv.position();

            var selectedAnswerLetter = skyward.controls.getValue(choiceDiv.find(".matchingAnswerChoiceAnswers"));
            var answerLabel = matchingAnswersContainer.find(".matchingAnswerMatchLabel:contains('" + selectedAnswerLetter + "')");
            var matchDiv = answerLabel.parents(".matchingAnswerMatchContainer").first();
            var matchNumber = matchDiv.prevAll(".matchingAnswerMatchContainer").length + 1;
            var matchPosition = matchDiv.position();
            if (matchPosition != null)
            {
                matchPosition.top += matchDiv.height() / 2;
            }

            var line = middleDiv.find(".matchingChoiceLine" + choiceNumber);

            if (selectedAnswerLetter != null && selectedAnswerLetter != "" && selectedAnswerLetter != " ")
            {
                var color = getColor(matchNumber, choiceDiv);

                if (line.hasClass("hidden"))
                {
                    line.removeClass("hidden");
                }

                line.attr('stroke', color);

                setLineCoordinates(choiceDiv, line, middleDiv, choicePosition, matchPosition);

                setMatchingBorder(choiceDiv, color);
                setMatchingBorder(matchDiv, color);
            }
            else
            {
                if (!line.hasClass("hidden"))
                {
                    line.addClass("hidden");
                }

                choiceDiv.css('border', '');
            }
        };

        var removeBordersForUnusedMatches = function (matchingAnswersContainer)
        {
            matchingAnswersContainer.find(".matchingAnswerMatchContainer").each(function ()
            {
                var matchingAnswerMatchContainer = $(this);
                var letter = matchingAnswerMatchContainer.find(".matchingAnswerMatchLabel").html()[0];

                var hasChoicePointingToMatch = false;
                matchingAnswersContainer.find(".matchingAnswerChoiceAnswers").each(function()
                {
                    if (skyward.controls.getValue($(this)) == letter)
                    {
                        hasChoicePointingToMatch = true;
                    }
                });

                if (!hasChoicePointingToMatch)
                {
                    matchingAnswerMatchContainer.css('border', '');
                }
            });
        };

        var addChoice = function ()
        {
            var container = $(this).parents(".matchingAnswersContainer");
            addItem(false, container);
            handleComboBoxes(container);
            repositionLines(container);
        };

        var addMatch = function ()
        {
            var addButton = $(this);
            var container = addButton.parents(".matchingAnswersContainer");
            addItem(true, container, addButton);
            handleComboBoxes(container);
            repositionLines(container);
        };

        var addItem = function (isMatch, container, addButton)
        {
            var itemContainerName = isMatch ? ".matchingAnswerMatchesContainer" : ".matchingAnswerChoicesContainer";
            var specificContainerName = isMatch ? ".matchingAnswerMatchContainer" : ".matchingAnswerChoiceContainer";
            var labelName = isMatch ? ".matchingAnswerMatchLabel" : ".matchingAnswerChoiceLabel";
            var textBoxName = isMatch ? ".matchingAnswerMatch" : ".matchingAnswerChoice";

            var itemContainers = container.find(itemContainerName);
            var items = itemContainers.children(specificContainerName);
            if (isMatch && items.length >= 25)
            {
                addButton.addClass('ui-disabled');
                if (isMatch && items.length > 25)
                {
                    return;
                }
            }

            var template = container.find(itemContainerName).parents("div.matchingContainerDiv").first().find(".template");
            var newItem = template.clone(true);
            newItem.removeClass("template");
            newItem.removeClass("hidden");
            var label = newItem.find(labelName);
            var textBox = newItem.children(textBoxName);
            var identifier = parseInt(getIdentifier(items.last(), isMatch)) + 1;

            if (isMatch)
            {
                var letter = String.fromCharCode(64 + identifier);
                label.text(letter + ".");
            }
            else
            {
                label.text(identifier + ".");
                var selectInput = newItem.children(".matchingAnswerChoiceAnswers");
                skyward.controls.setValue(selectInput, " ");
            }

            updateImageElementIDs(newItem, identifier);

            skyward.controls.setValue(textBox, "");
            newItem.appendTo(itemContainers);
            textBox.focus();
            var backingData = getBackingData(container.find(".matchingBackingData"));

            if (isMatch) {
                backingData.Matches.push(
                    {
                        Identifier: identifier,
                        QuestionAnswerID: null,
                        Text: null
                    })
            }
            else {
                backingData.Choices.push(
                    {
                        Identifier: identifier,
                        Choice: null,
                        AnswerText: null,
                        AnswerIdentifier: null,
                        QuestionAnswerID: null
                    })
            }

            skyward.controls.setValue(container.find(".matchingBackingData"), JSON.stringify(backingData));
            skyward.window.notifyDOMLoad('#' + container.attr("id"));
        }

        var updateImageElementIDs = function (element, newID)
        {
            var imageUploadClassName = ".hasIdentifierToIncrement";
            var imageElements = element.find(imageUploadClassName);
            var imageElementChildren = imageElements.find('*');
            var updateElement = function (element, attributeName)
            {
                var childId = $(element).attr(attributeName);

                if (childId)
                {
                    var childIdParts = childId.split('-');
                    var updatedId;

                    if (childIdParts.length >= 2)
                    {
                        childIdParts[childIdParts.length - 2] = newID;
                        updatedId = childIdParts.join('-');
                        $(element).attr(attributeName, updatedId);
                    }
                }
            };
            var updateElementAttributes = function ()
            {
                updateElement($(this), 'id');
                updateElement($(this), 'name');
                updateElement($(this), 'data-value-input-id');
            };

            imageElements.each(updateElementAttributes);
            imageElementChildren.each(updateElementAttributes);
        }

        var clearMatchingMatch = function ()
        {
            var currentMatchingMatch = $(this).parents(".matchingAnswerMatchContainer");
            $(this).parents(".matchingContainerDiv").find(".matchingAddItem").removeClass('ui-disabled');
            clearMatchingItem(currentMatchingMatch, true);
        };

        var clearMatchingChoice = function ()
        {
            var currentMatchingChoice = $(this).parents(".matchingAnswerChoiceContainer");
            var container = currentMatchingChoice.parents(".matchingAnswersContainer").first();

            clearMatchingItem(currentMatchingChoice, false);
            repositionLines(container);
            removeBordersForUnusedMatches(container);
        };

        var clearMatchingItem = function (current, isMatch)
        {
            var classSelector = isMatch ? ".matchingAnswerMatch" : ".matchingAnswerChoice";
            var singleContainer = classSelector + "Container";
            var multipleContainer = isMatch ? classSelector + "esContainer" : classSelector + "sContainer"
            var fileNumberElement = current.find("input[id*='fNumber']");
            var fileListElement = current.find(".onlineAssignmentQuestionAnswerFileList");

            if (current.parents(multipleContainer).find(singleContainer).length < 2)
            {
                var matchTextBox = current.children(classSelector);
                skyward.controls.setValue(matchTextBox, "");

                //clear image fields
                current.find("img").remove();
                if (fileNumberElement[0].value)
                {
                    //it has a value which means something has been uploaded, so use the framework for removing it
                    var clearButton = fileListElement.find("a[id*='Delete']")[0];

                    if (clearButton)
                    {
                        clearButton.click();
                    }
                }
                else
                {
                    //set the fileNumber to 0 so that the save action deletes it.
                    fileNumberElement[0].value = "0";
                    fileNumberElement.trigger('change');
                }
            }
            else
            {
                var parent = current.parents(multipleContainer);
                current.remove();
                var selections = parent.children(singleContainer);
                var counter = 1
                selections.each(function ()
                {
                    var currentSelection = $(this);
                    var label = isMatch ? currentSelection.find(".matchingAnswerMatchLabel") : currentSelection.find(".matchingAnswerChoiceLabel");                    
                    var letter = String.fromCharCode(64 + counter);
                    if (isMatch)
                    {
                        label.text(letter + ".");
                    }
                    else
                    {
                        label.text(counter + ".");
                    }
                    updateImageElementIDs(currentSelection, counter);
                    counter++;
                });

                var identifier = getIdentifier(current, isMatch);

                if (isMatch)
                {
                    clearOutAffectedChoices(parent.parents(".matchingAnswersContainer"), identifier);
                    handleComboBoxes(parent.parents(".matchingAnswersContainer"));
                }

                //delete the uploaded file if it exists.
                if (fileNumberElement[0].value && fileNumberElement[0].value != "0")
                {
                    fileListElement.find("a[id*='Delete']")[0].click();
                }

                //If we are clearing something that has a QuestionAnswerID
                //then we need to know to delete something?
                //Or maybe whenever we save we always get all existing, if questionanswerID
                //isnt in dom at all then delete it (either in choice or match)

                removeItemFromBackingData(parent, identifier, isMatch);
            }
        }

        var getIdentifier = function (element, isMatch) {

            var label;
            var value;
            if (isMatch)
            {
                label = element.find(".matchingAnswerMatchLabel");
                value = label.html();

                if (value)
                {
                    var letter = value.substring(0, value.length - 1);
                    return letter.charCodeAt() - 64;
                }

                return -1;
            }

            label = element.find(".matchingAnswerChoiceLabel");
            value = label.html();
            var number = value.substring(0, value.length - 1);
            return number;
        };

        var getMatch = function (backingData, identifier)
        {
            var selectedMatch = null;
            $.each(backingData.Matches, function (k, match) {
                if (match.Identifier == identifier)
                {
                    selectedMatch = match;
                }
            });

            return selectedMatch;
        };

        var getChoice = function (backingData, identifier)
        {
            var selectedChoice = null;
            $.each(backingData.Choices, function (k, choice) {
                if (choice.Identifier == identifier)
                {
                    selectedChoice = choice;
                }
            });

            return selectedChoice;
        };

        var getChoicesForMatch = function (backingData, match) {
            var choices = [];
            $.each(backingData.Choices, function (k, choice) {
                if (choice.AnswerIdentifier == match.Identifier) {
                    choices.push(choice);
                }
            });

            return choices;
        };

        var getAnswerIdentifierFromChoiceSelection = function (selectInput)
        {
            var letter = skyward.controls.getValue(selectInput);

            if (letter == " ")
            {
                return -1;
            }
            var answerLabel = selectInput.parents(".matchingAnswersContainer").find(".matchingAnswerMatchLabel:contains('" + letter + "')");

            return getIdentifier(answerLabel.parents(".matchingAnswerMatchContainer"), true);
        };

        var removeItemFromBackingData = function(container, indentifier, isMatch)
        {
            var backingDataElement = container.parents(".matchingAnswersContainer").find(".matchingBackingData");
            var backingData = getBackingData(backingDataElement);
            var id = indentifier;
            if (isMatch) {

                var tmpMatches = backingData.Matches;
                backingData.Matches = [];

                $.each(tmpMatches, function (k, match) {
                    var choices = getChoicesForMatch(backingData, match)

                    if (match.Identifier == id) {
                        //find any choices that had this picked and clear
                        for (var i = 0; i < choices.length; i++) {
                            var choice = choices[i];
                            choice.AnswerText = null;
                            choice.AnswerIdentifier = null;
                        }
                    }
                    else
                    {
                        if (parseInt(match.Identifier) > parseInt(id)) {
                            //find any choices that had this picked and clear
                            match.Identifier = backingData.Matches.length + 1;

                            for (var i = 0; i < choices.length; i++) {
                                var choice = choices[i];
                                choice.AnswerIdentifier = match.Identifier;
                            }
                        }

                        backingData.Matches.push(match);
                    }
                });
            }
            else {
                var tmpChoices = backingData.Choices;
                backingData.Choices = [];

                var counter = 1;
                $.each(tmpChoices, function (k, choice) {
                    if (choice.Identifier != id) {
                        backingData.Choices.push(choice);
                        choice.Identifier = counter;
                        counter++;
                    }
                });
            }

            skyward.controls.setValue(backingDataElement, JSON.stringify(backingData));
        }

        var clearOutAffectedChoices = function (container, identifier)
        {
            var letter = String.fromCharCode(64 + identifier);
            var comboboxes = container.find(".matchingAnswerChoiceAnswers");
            comboboxes.each(function ()
            {
                var comboBox = $(this);
                var selectedValue = comboBox.find(":selected").text();
                if (selectedValue >= letter)
                {
                    skyward.controls.setValue(comboBox, " ");
                }
            });
        };

        var handleComboBoxes = function (container)
        {
            var matches = container.find(".matchingAnswerMatchContainer:not(.template)");
            var comboboxes = container.find(".matchingAnswerChoiceAnswers");
            comboboxes.each(function ()
            {
                currentComboBox = $(this);
                var selectedValue = currentComboBox.find(":selected").text();
                var template = currentComboBox.children().last().clone();
                currentComboBox.children().remove();

                var currentTemplate = template.clone();
                currentTemplate.attr("value", " ");
                currentTemplate.text(" ");
                currentTemplate.appendTo(currentComboBox);
                matches.each(function ()
                {
                    var match = $(this);
                    var letter = match.find(".matchingAnswerMatchLabel");
                    currentTemplate = template.clone();
                    var text = letter.text().slice(0, 1);

                    currentTemplate.attr("value", text);
                    currentTemplate.text(text);
                    currentTemplate.appendTo(currentComboBox);
                });
                var options = currentComboBox.children();
                options.each(function ()
                {
                    currentOption = $(this);
                    currentOption.removeAttr('selected');
                    if(currentOption.text() == selectedValue)
                    {
                        currentOption.attr('selected', 'selected');
                    }
                });
            });
        }

        var resizeMatchingAnswerContainer = function ()
        {
            $(".matchingAnswersContainer").each(function ()
            {
                repositionLines($(this))
            });
        };

        var loadHTMLViewer = function ()
        {
            var htmlViewerElement = $(this);
            var data = htmlViewerElement.data();

            var isLoading = htmlViewerElement && htmlViewerElement.get(0) && htmlViewerElement.get(0).contentDocument.readyState == "loading";
            var isComplete = htmlViewerElement && htmlViewerElement.get(0) &&
                (htmlViewerElement.get(0).contentDocument.readyState == "complete" || htmlViewerElement.get(0).contentDocument.readyState == "interactive");

            htmlViewerElement.hide();

            var internalOnLoad = function ()
            {
                var htmlViewer = htmlViewerElement.get(0);

                if (htmlViewer.contentWindow == null || htmlViewer.contentWindow.document == null || htmlViewer.contentWindow.document.body == null)
                {
                    setTimeout(function ()
                    {
                        internalOnLoad();
                    }, 50);
                }
                else
                {
                    htmlViewer.contentWindow.document.body.style.background = 'none';
                    if (data.minWidth)
                    {
                        htmlViewer.contentWindow.document.body.style.minWidth = data.minWidth;
                    }
                    if (data.maxWidth)
                    {
                        htmlViewer.contentWindow.document.body.style.maxWidth = data.maxWidth
                    }
                    htmlViewerElement.off('load');
                    htmlViewerElement.show();
                    htmlViewer.height = htmlViewer.contentWindow.document.body.clientHeight + 40; //htmlViewerElement.contents().height();

                    var maxWidthNumber;
                    if (data.maxWidth && data.maxWidth.indexOf("px") > -1)
                    {
                        maxWidthNumber = data.maxWidth.substring(0, data.maxWidth.indexOf("px"));
                    }
                    var minWidthNumber;
                    if (data.minWidth && data.minWidth.indexOf("px") > -1)
                    {
                        minWidthNumber = data.minWidth.substring(0, data.minWidth.indexOf("px"));
                    }
                    if (maxWidthNumber < htmlViewerElement.contents().width() + htmlViewer.contentWindow.document.body.scrollWidth)
                    {
                        htmlViewer.width = maxWidthNumber;
                    }
                    else if (minWidthNumber && minWidthNumber > htmlViewerElement.contents().width() + htmlViewer.contentWindow.document.body.scrollWidth)
                    {
                        htmlViewer.width = minWidthNumber;
                    }
                    else
                    {
                        var addScrollWidth = htmlViewerElement.parents(".matchingAnswerChoiceContainer").length < 1 &&
                            htmlViewerElement.parents(".matchingAnswerMatchContainer").length < 1 &&
                            htmlViewerElement.parents(".onlineAssignmentQuickEntryMinWidthMC").length < 1 &&
                            htmlViewerElement.parents(".instructionsAdvancedTextArea").length < 1;

                        var scrollWidth = htmlViewer.contentWindow.document.body.scrollWidth;
                        if (!addScrollWidth)
                        {
                            scrollWidth = 0;
                        }
                        htmlViewer.width = htmlViewerElement.contents().width() + scrollWidth;
                    }
                }

            };
            if (isLoading)
            {
                htmlViewerElement.on("load", function ()
                {
                    internalOnLoad();
                });


            }
            else if (isComplete)
            {
                setTimeout(function ()
                {
                    internalOnLoad();
                }, 50);
            }

        };

        var previewQuestion = function ()
        {
            var button = $(this);
            var data = button.data();
            var controller = data.controller;

            var buildPopup = function ()
            {
                return $.ajax({
                    url: skyward.global.virtualDir + "Gradebook/" + controller + "/PreviewQuestion",
                    activityIndicator: { silent: true },
                    type: "POST",
                    dataType: "viewparthtml",
                    data: data
                });
            };

            var options =
            {
                draggable: true,
                closeOnEscape: true,
                id: 'PreviewQuestion',
                additionalClasses: 'previewQuestion'
            };

            var dialog = skyward.modalLayer.showDialog("Preview Question", buildPopup, { text: "Close", icon: "Close", click: function () {  dialog.close(); } }, options);
            dialog.modalLayer.uniqueId = 0;
        };


        var events =
        {
            'addChoice': addChoice,
            'addMatch' :addMatch,
            'clearMatchingChoice': clearMatchingChoice,
            'clearMatchingMatch': clearMatchingMatch,
            'loadHTMLViewer': loadHTMLViewer,
            'previewQuestion': previewQuestion
        };
        //Bootstrap
        skyward.window.registerLoadDOMCallback(init);
        skyward.window.registerLayoutResizeCallback(resizeMatchingAnswerContainer);
        skyward.events.registerEvents('gradebookquestion', events);

    }(window.skyward = window.skyward || {}, window.jQuery)
);